import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import InfoCard from 'components/Info/InfoCard';
import { translate } from 'components/Translation';
import { AccountCell } from 'components/Cells/Cells';
import CustomAvatar from 'components/CustomAvatar/CustomAvatar';
import Business from '@material-ui/icons/Business';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingAccounts/detailsStyle';
import { makeStyles } from '@material-ui/core';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillingAccountInformationProps {
	billingType: string;
	accountId: string;
	billingId: string;
	isEBill: boolean;
	account: SingleCorpAccount | null;
}

const BillingAccountInformation = ({
	billingType,
	accountId,
	billingId,
	isEBill,
	account,
}: IBillingAccountInformationProps) => {
	const classes = useStyles();

	const billingAccountType = billingType.toLowerCase().replace('_', '-');

	return (
		<GridItem xs={12}>
			<GridContainer justify="flex-start">
				<GridItem xs={12} lg={6} className={classes.cardItem}>
					<InfoCard
						title={translate('payments.billingAccounts.information')}
						elements={[
							{
								title: translate('payments.billingAccounts.billingAccountType'),
								value: translate(`numbers.${billingAccountType}`),
							},
							{
								title: translate('payments.billingAccounts.billingAccountNumber'),
								value: billingId,
							},
							{
								title: translate('payments.billingAccounts.invoiceType'),
								value: isEBill
									? translate('payments.billingAccounts.ebill')
									: translate('payments.billingAccounts.paper'),
							},
							{
								title: translate('organization.name'),
								value: (
									<div className={classes.accountCellWrapper}>
										<AccountCell
											text={account?.accountName || ''}
											icon={
												<CustomAvatar
													accountId={accountId}
													alt="Company Logo"
													placeholderIcon={<Business />}
													customClasses={classes.inlineIcon}
												/>
											}
										/>
									</div>
								),
							},
						]}
					/>
				</GridItem>
			</GridContainer>
		</GridItem>
	);
};

export default BillingAccountInformation;
